export class ComplexMultiselectDomain {
  protected complexMultiSelectData: any = {};

  getComplexMultiSelectFieldHandler({
    selectedIds = [],
    selectedCategoryId = null,
    selectedCategoryValues = [],
    onChange,
    specificationCategory = null,
  }: {
    selectedIds: string[];
    selectedCategoryId: string | null | undefined;
    selectedCategoryValues: { value: string }[];
    onChange: (specificationIds: string[]) => void;
    specificationCategory?
  }) {
    if (!selectedCategoryId) {
      return (newValueList: { value?: string }[]) => {
        const newValues = newValueList.map((value) => value.value || '');
        onChange(newValues);
      };
    } else {
      const currentCategoryValues = selectedCategoryValues
        .filter((valueData: { value: string }) => selectedIds.includes(valueData.value))
        .map((valueData: { value: string }) => valueData.value);

      if (currentCategoryValues.length > 0 || !this.complexMultiSelectData[selectedCategoryId]) {
        this.complexMultiSelectData[selectedCategoryId] = currentCategoryValues;
      } else {
        const existingValues = this.complexMultiSelectData[selectedCategoryId] || [];
        const validExistingValues = existingValues.filter(id => selectedIds.includes(id));
        if (validExistingValues.length > 0) {
          this.complexMultiSelectData[selectedCategoryId] = validExistingValues;
        }
      }

      return (newValueList: { value?: string }[]) => {
        const newCategoryValues = newValueList.map((value) => value.value).filter((id): id is string => !!id);
        this.complexMultiSelectData[selectedCategoryId] = newCategoryValues;

        let resultIds: string[] = [...selectedIds];

        const categoryValueIds = selectedCategoryValues.map(v => v.value).filter((id): id is string => !!id);
        resultIds = resultIds.filter(id => !categoryValueIds.includes(id));

        resultIds = [...resultIds, ...newCategoryValues];

        for (let categoryId in this.complexMultiSelectData) {
          if (categoryId !== selectedCategoryId) {
            this.complexMultiSelectData[categoryId].forEach((id: string) => {
              if (!resultIds.includes(id)) {
                resultIds.push(id);
              }
            });
          }
        }

        onChange(resultIds);
      };
    }
  }
}
